var swiper = new Swiper(".topbarsswiper", { navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }, autoplay: { delay: 4e3, disableOnInteraction: !1 } }),
    swiper = new Swiper(".homeslider", { navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }, autoplay: { delay: 4e3, disableOnInteraction: !1 }}),
    swiper = new Swiper(".homepiconsdeat", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 4, spaceBetween: 5 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 7, spaceBetween: 10 } },
    }),


swiper = new Swiper(".homeslider-gifting", { navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }, }),



   swiper = new Swiper(".home-ecom", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 2, spaceBetween: 5 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 5, spaceBetween: 20 } },
    }),


   swiper = new Swiper(".top-the-category-slide", {
        slidesPerView: 1,
     loop: false,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 4.3, spaceBetween: 7 }, 468: { slidesPerView: 5, spaceBetween: 20 }, 768: { slidesPerView: 6, spaceBetween: 20 }, 1024: { slidesPerView: 10, spaceBetween: 20 } },
    }),


  
   swiper = new Swiper(".offer-str", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 1, spaceBetween: 5 }, 768: { slidesPerView: 3, spaceBetween: 20 }, 1024: { slidesPerView: 3, spaceBetween: 10 } },
    }),


  
    swiper = new Swiper(".youMaylikke", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 2, spaceBetween: 10 }, 768: { slidesPerView: 4, spaceBetween: 40 }, 1024: { slidesPerView: 4, spaceBetween: 50 } },
    }),
    swiper = new Swiper(".byskintype", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 2, spaceBetween: 10 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 4, spaceBetween: 20 } },
    }),
    swiper = new Swiper(".byskinconcerns", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 2, spaceBetween: 10 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 4, spaceBetween: 20 } },
    }),
    swiper = new Swiper(".awardssec", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 3, spaceBetween: 10 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 6, spaceBetween: 30 } },
    }),
    swiper = new Swiper(".blogssldiers", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 1, spaceBetween: 10 }, 768: { slidesPerView: 2, spaceBetween: 20 }, 1024: { slidesPerView: 3, spaceBetween: 30 } },
    }),
    swiper = new Swiper(".happycustomer", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        breakpoints: { 0: { slidesPerView: 1.3, spaceBetween: 10 }, 468: { slidesPerView: 2.5, spaceBetween: 20 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 4, spaceBetween: 20 } },
    }),
    swiper = new Swiper(".homepagetabs", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 2, spaceBetween: 10 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 5, spaceBetween: 30 } },
    }),
    swiper = new Swiper(".asseeninsec", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 3, spaceBetween: 10 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 6, spaceBetween: 30 } },
    }),
    swiper = new Swiper(".customcollection", {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 2 }, 768: { slidesPerView: 3 }, 1024: { slidesPerView: 4 } },
    }),
    swiper = new Swiper(".youmayalsolike", {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", clickable: !0 },
        breakpoints: { 0: { slidesPerView: 2, spaceBetween: 10 }, 768: { slidesPerView: 3 }, 1024: { slidesPerView: 4 } },
    }),
    swiper = new Swiper(".prestigiousaw", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        breakpoints: { 0: { slidesPerView: 3, spaceBetween: 10 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 6, spaceBetween: 50 } },
    }),
    swiper = new Swiper(".presticate", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        breakpoints: { 0: { slidesPerView: 3, spaceBetween: 10 }, 768: { slidesPerView: 4, spaceBetween: 20 }, 1024: { slidesPerView: 6, spaceBetween: 15 } },
    }),
    swiper = new Swiper(".prestipomo", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        breakpoints: { 0: { slidesPerView: 1.3, spaceBetween: 20 }, 768: { slidesPerView: 2.5, spaceBetween: 20 }, 1024: { slidesPerView: 2.5, spaceBetween: 20 } },
    }),
    swiper = new Swiper(".collectionslider", {
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        breakpoints: { 0: { slidesPerView: 2, spaceBetween: 20 }, 768: { slidesPerView: 3, spaceBetween: 20 }, 1024: { slidesPerView: 4, spaceBetween: 15 } },
    }),

    swiper = new Swiper(".productthumbs2", { spaceBetween: 10, slidesPerView: 7, freeMode: !0, watchSlidesProgress: !0 }),
    swiper2 = new Swiper(".productthumbs", { spaceBetween: 10, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }, thumbs: { swiper: swiper } });

function copyToClipboard(e) {
    var i = $("<input>");
    $("body").append(i);
    i.val($(e).text()).select();
    document.execCommand("copy");
    i.remove();
}


// Result hover
$(".result").hover(function () {
    $(this).toggleClass("result_hover");
});


// Navigation toggle 1
$(".nav-toggle1").click(function () {
    $(".nav-toggle1").toggleClass("active");
    $(".nav-items1").slideToggle();
});


// Navigation toggle 2
$(".nav-toggle2").click(function () {
    $(".nav-toggle2").toggleClass("active");
    $(".nav-items2").slideToggle();
});


// Navigation toggle 3
$(".nav-toggle3").click(function () {
    $(".nav-toggle3").toggleClass("active");
    $(".nav-items3").slideToggle();
});


// Navigation toggle 4
$(".nav-toggle4").click(function () {
    $(".nav-toggle4").toggleClass("active");
    $(".nav-items4").slideToggle();
});


// Navigation toggle 5
$(".nav-toggle5").click(function () {
    $(".nav-toggle5").toggleClass("active");
    $(".nav-items5").slideToggle();
});


// jQuery Plugin
window.jQueryPlugin = function (e, i) {
    return function (t) {

        return this.length > 1
            ? (
                this.each(function () {
                    var n = $(this);

                    n.data(e) || n.data(e, i(n, t));
                }),
                this
            )
            : 1 === this.length
                ? (
                    this.data(e) || this.data(e, i(this, t)),
                    this.data(e)
                )
                : void 0;
    };
};


// Guantity Plugin
$.fn.Guantity = jQueryPlugin("Guantity", function e(i) {

    i.first("data-quantity");

    let t = i.find("[data-quantity-target]");
    let n = i.find("[data-quantity-minus]");
    let s = i.find("[data-quantity-plus]");

    var a = t.val();

    $(n).click(function () {
        t.val(--a);
    });

    $(s).click(function () {
        t.val(++a);
    });

});


// Initialize Guantity
$("[data-quantity]").Guantity();


// ==============================
// MODAL 1
// ==============================

var modal1 = document.getElementById("myModal1");
var btn1 = document.getElementById("myBtn1");
var span1 = document.getElementsByClassName("close")[1];

if (btn1 && modal1) {
    btn1.onclick = function () {
        modal1.style.display = "block";
    };
}

if (span1 && modal1) {
    span1.onclick = function () {
        modal1.style.display = "none";
    };
}


// ==============================
// MODAL 2
// ==============================

var modal2 = document.getElementById("myModal2");
var btn2 = document.getElementById("myBtn2");
var span2 = document.getElementsByClassName("close")[2];

if (btn2 && modal2) {
    btn2.onclick = function () {
        modal2.style.display = "block";
    };
}

if (span2 && modal2) {
    span2.onclick = function () {
        modal2.style.display = "none";
    };
}


// ==============================
// CLOSE MODAL ON OUTSIDE CLICK
// ==============================

window.addEventListener("click", function (e) {

    if (modal1 && e.target === modal1) {
        modal1.style.display = "none";
    }

    if (modal2 && e.target === modal2) {
        modal2.style.display = "none";
    }

});